// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ac08e42d{position:relative}", "",{"version":3,"sources":["webpack://./src/common/components/Dropdown/Base/DropdownBase.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA","sourcesContent":[".dropdownbase {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownbase": "ac08e42d"
};
export default ___CSS_LOADER_EXPORT___;
